import { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { Row, Col, Button, Overlay, Popover } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import { VzPageContainer } from "../../layouts/VzPageContainer";
import ServerSideDataTable from "../../layouts/DataTables/ServerSideDataTable/ServerSideDataTable";
import { Formik, Form } from "formik";
import FormikControl from "../../layouts/Input/FormikControl";
import { getDropdownList } from "../Shared/dropdownListActions";
import axios from "../../apis/Api";
import { GET_DISTRIBUTOR_DDL } from "../../Types";
import { toast } from "react-toastify";
import {
  getMBLDistributorOnboardingList,
} from "./MBLDistributorOnboardingListActions";
import storage from "../../apis/Storage";
import { formatDate } from "../../utilities/FUNCTIONS";
import Moment from "react-moment";

const MBLDistributorOnboardingList = (props) => {
  const history = useHistory();
  const userRights = JSON.parse(storage.get("_userRights"));

  /* ================= PAGINATION ================= */
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentPageNo, setCurrentPageNo] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(5);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [distributorList, setDistributorList] = useState([]);
  const [isApplyFilter, setIsApplyFilter] = useState(false);


  /* ================= STATUS OPTIONS ================= */
  const onboardingStatusOptions = [
    { label: "Pending", value: 1 },
    { label: "In Review", value: 2 },
    { label: "Approved", value: 3 },
    { label: "Rejected", value: 4 },
  ];

  /* ================= FILTER ================= */
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const ref = useRef(null);

  const [filter, setfilter] = useState({
    distributor: null,
    fromDate: new Date(),
    toDate: new Date(),
    pageNo: 0,
    pageSize: 5,
    searchText: null,
    isExport: false,
  });

  /* ================= ROUTE NAVIGATION ================= */
  const addNewRecord = () => {
    history.push("/mbl-distributor-onboarding/add");
  };

  const editRecord = (id) => {
    history.push(`/mbl-distributor-onboarding/edit/${id}`);
  };

  const viewRecord = (id) => {
    history.push(`/mbl-distributor-onboarding/view/${id}`);
  };

  /* ================= TABLE ================= */
  const columns = [
    { Header: "Date", accessor: "date",
       Cell: (row) => (
        <div style={{ width: "75px" }}>
          <Moment format="DD/MM/YYYY">{row.value}</Moment>
        </div>
      ), },
    { Header: "Distributor", accessor: "distributorName" },
    { Header: "Total Shops", accessor: "totalShops" },
    { Header: "Assign Limit", accessor: "assignLimit" },
    { Header: "Anchor Status", accessor: "onboardingStatus" },
    { Header: "Profile Status", accessor: "profileStatus" },
    {
      Header: "Action",
      accessor: "id",
      Cell: ({ row: { original } }) => (
        <div className="d-flex" style={{ width: "110px" }}>
          <button
            className="btn btn-sm"
            style={{
              display:
                original.anchorStatus === "Pending" ||
                original.anchorStatus === "Approved"
                  ? "none"
                  : "block",
            }}
            onClick={() => editRecord(original.distributorId)}
          >
            <i className="fas fa-edit" />
          </button>
          &nbsp;
          <button
            className="btn btn-sm"
            onClick={() => viewRecord(original.distributorId)}
          >
            <i className="fas fa-eye" />
          </button>
        </div>
      ),
    },
  ];

  /* ================= FILTER HELPERS ================= */
  const openFilterModal = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  const handleResetFilters = (resetForm) => {
    resetForm();
    setfilter({
      distributor:
        userRights?.userType === "DistributorUser"
          ? filter.distributor
          : null,
      fromDate: new Date(),
      toDate: new Date(),
      pageNo: 0,
      searchText: null,
      isExport: false,
    });
  };

  const LoadDataByfilter = (event) => {
    setCurrentPageNo(0);
    var request = { ...formRequestObject(), pageNo: 0 };
    fetchReportData(request);
    setShow(false);
    setIsApplyFilter(true);
  };

    function commonReset(reset = true) {
    if (reset) {
      setfilter({
        distId:
          userRights != null && userRights?.userType == "DistributorUser"
            ? filter.distributor
            : null,
        distCenterId: null,
        financerId: null,
        vizId: "",
        invoiceNo: "",
        loanId: "",
        status: null,
        fromDate: new Date(),
        toDate: new Date(),
        pageNo: 0,
        searchText: null,
      });
    }
  }

  /* ================= DATA ================= */
  const searchChanged = (text) => {
    setCurrentPageNo(0);
    setSearchText(text);
  };

  const getData = (page) => {
    setCurrentPageNo(page);
    fetchReportData({ ...formRequestObject(), pageNo: page });
  };

  const pageSizeChanged = (pageSize) => {
    setCurrentPageNo(0);
    setCurrentPageSize(pageSize);
    fetchReportData({ ...formRequestObject(), pageSize });
  };

  function formRequestObject(isExport = false) {
    let requestData = {
      distributorId: filter.distributor?.value,
      fromDate: formatDate(filter.fromDate),
      toDate: formatDate(filter.toDate),
      pageSize: currentPageSize,
      pageNo: currentPageNo,
      searchText,
      isExport,
    };

    if (
      userRights?.userType === "DistributorUser" ||
      userRights?.userType === "CoreAppUser"
    ) {
      requestData.distributorId = userRights?.distributorId;
    }

    return requestData;
  }

  function fetchReportData(request) {
    props.getMBLDistributorOnboardingList(
      request ?? formRequestObject()
    );
  }

  /* ================= EFFECTS ================= */
  useEffect(() => {
    fetchReportData();
  }, [searchText]);

    // useEffect(() => {
    //   if (
    //     props.MBLDistributorOnboardingList &&
    //     props.MBLDistributorOnboardingList.totalRecords > 0
    //   ) {
    //     setTotalRecords(props.MBLDistributorOnboardingList.totalRecords);
    //   } else {
    //     setTotalRecords(0);
    //   }
    // }, [props.MBLDistributorOnboardingList]);
  

  useEffect(() => {
    props.getDropdownList(
      "api/Distributor/GetDistributorsDDL",
      GET_DISTRIBUTOR_DDL
    );
  }, []);

  /* ================= RENDER ================= */
  return (
    <VzPageContainer title="Mbl Distributor Onboarding">
      <Row>
        <Col>
          <h4>
            <b>Mbl Distributor Onboarding</b>
          </h4>
        </Col>
      </Row>

      <Row>
         <Col md={10} style={{ float: "right" }}>
          <div ref={ref}>
            <Button
              onClick={openFilterModal}
              className="m-3"
              variant="outline-primary"
            >
              <i className="fa fa-filter" />
              Filters
            </Button>

            <Overlay
              show={show}
              target={target}
              placement="bottom"
              container={ref}
              containerPadding={20}
              width="430px"
              style={{ width: "430px" }}
            >
              <Popover
                id="popover-contained"
                style={{ maxWidth: "360px", width: "360px" }}
              >
                <Popover.Header as="h3">Filters</Popover.Header>
                <Popover.Body>
                  <Formik
                    enableReinitialize
                    initialValues={filter}
                    validator={() => ({})}
                    onSubmit={LoadDataByfilter}
                  >
                    {(formik) => (
                      <Form autoComplete="off">
                        <Row>
                          {userRights == null && (
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Distributor"
                                name="distributor"
                                options={distributorList}
                                isClearable={true}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  if (!e || !e.value) {
                                    setfilter({
                                      ...filter,
                                      distId: null,
                                    });
                                    return;
                                  }
                                  setfilter({
                                    ...filter,
                                    distId: {
                                      label: e.label,
                                      value: e.value,
                                    },
                                    distCenterId: [],
                                  });
                                }}
                                value={filter.distId}
                              />
                            </Col>
                          )}
                          <Col xs={12} md={12}>
                                <FormikControl
                            formik={formik}
                            control="react-select"
                            label="Status"
                            options={onboardingStatusOptions}
                            value={filter.onboardingStatus}
                            handleOnChange={(e) =>
                              setfilter({
                                ...filter,
                                onboardingStatus: e
                                  ? { label: e.label, value: e.value }
                                  : null,
                              })
                            }
                          />
                          </Col>
                          <Row style={{ paddingRight: 0 }}>
                            <Col xs={12} md={6}>
                              <FormikControl
                                formik={formik}
                                type="fromDate"
                                control="date"
                                label="From Date"
                                name="fromDate"
                                handleOnChange={(value) => {
                                  setfilter({ ...filter, fromDate: value });
                                }}
                                value={filter.fromDate}
                              />
                            </Col>
                            <Col xs={12} md={6}>
                              <FormikControl
                                formik={formik}
                                control="date"
                                type="toDate"
                                label="To Date"
                                name="toDate"
                                handleOnChange={(value) => {
                                  setfilter({ ...filter, toDate: value });
                                }}
                                value={filter.toDate}
                              />
                            </Col>
                          </Row>
                        </Row>
                        <div className="row" style={{ marginTop: 20 }}>
                          <div className="form-group">
                            <Link
                              onClick={handleResetFilters.bind(
                                null,
                                formik.resetForm,
                                setIsApplyFilter(false)
                              )}
                              to="#"
                              className="active"
                              style={{
                                padding: "0px",
                                marginTop: "10px",
                                float: "left",
                              }}
                            >
                              Reset
                            </Link>
                            <Link
                              onClick={() => {
                                setShow(false);
                                setTarget(null);
                                commonReset(isApplyFilter);
                              }}
                              to="#"
                              className="active"
                              style={{
                                padding: "0px",
                                marginTop: "10px",
                                float: "right",
                              }}
                            >
                              Cancel
                            </Link>
                            <div className="float-right">
                              <Button
                                type="submit"
                                className="btn btn-primary"
                                style={{
                                  marginRight: "10px",
                                  float: "right",
                                }}
                              >
                                Apply
                              </Button>
                            </div>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </Popover.Body>
              </Popover>
            </Overlay>
          </div>
        </Col>
        <Col md={2} className="d-flex justify-content-end">
          <Button
            onClick={addNewRecord}
            className="m-3"
            variant="outline-primary"
          >
            Add Request
          </Button>
        </Col>
      </Row>

      <Row>
        <Col>
          <ServerSideDataTable
            data={props.MBLDistributorOnboardingList ?? []}
            columns={columns}
            totalRecords={totalRecords}
            myPageSize={currentPageSize}
            myIndex={currentIndex}
            pageNo={currentPageNo}
            goToPreviousPage={getData}
            goToNextPage={getData}
            pageSizeChange={pageSizeChanged}
            searchChanged={searchChanged}
          />
        </Col>
      </Row>
    </VzPageContainer>
  );
};
//debugger;
const mapStateToProps = (state) => ({
  allDistributorList: state.ddlList.allDistributorList || [],
  MBLDistributorOnboardingList: state.MBLDistributorOnboardingList,
});

export default connect(mapStateToProps, {
  getDropdownList,
  getMBLDistributorOnboardingList,
})(MBLDistributorOnboardingList);
